import React from "react";
import { Navigate } from "react-router-dom";
import { useAppContext } from "../features/AppContext";
import Loader from "../components/Loader";

const PrivateRoute = ({ children }) => {
  const { user, isLoading } = useAppContext();

  return isLoading ? <><Loader /></> : user ? children : <Navigate to="/sign-in" />;
};

export default PrivateRoute;
